<template>
  <v-app>
    <Header :title="breadcrumb" />
    <v-container fluid>
      <v-row justify="start">
        <v-col cols="12" sm="10" md="8" lg="6">
          <v-card class="pa-4 pa-sm-6 pa-md-9">
            <v-form ref="form" lazy-validation>
              <v-text-field
                  label="Name"
                  v-model="form.name"
                  :rules="[() => !!form.name || 'This field is required']"
                  :error-messages="errorMessages"
                  required
              />

              <v-select
                  :items="getTimeSlots"
                  label="Duration"
                  v-model="form.durationInMint"
                  class="mt-5"
                  :rules="[() => !!form.durationInMint || 'This field is required']"
                  :error-messages="errorMessages"
              />

              <!-- Keep color as a hex string via v-model -->
              <v-color-picker
                  label="Color"
                  v-model="form.color"
                  mode="hex"
                  hide-mode-switch
                  hide-inputs
                  class="mb-4"
              />

              <v-row class="mt-7">
                <v-col cols="12" sm="6">
                  <v-btn
                      @click="updateAppointmentTypeService"
                      dark
                      color="#ae1431"
                      elevation="0"
                      block
                  >
                    Update Appointment Type
                  </v-btn>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-btn
                      outlined
                      elevation="0"
                      :to="{ name: 'AppointmentTypeServiceView' }"
                      block
                  >
                    Cancel
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import apolloClient from "@/apollo/apollo";
import gql from "graphql-tag";
import Header from "@/components/Header.vue";

export default {
  props: ["id"],
  components: { Header },
  data() {
    return {
      appointmentTypeServiceId: null,   // ✅ declare it so it’s reactive
      breadcrumb: "",
      errorMessages: "",
      form: {
        name: null,
        durationInMint: null,
        color: "#ffffff",               // ✅ use 6-digit hex default
      },
    };
  },

  methods: {
    async updateAppointmentTypeService() {
      if (this.appointmentTypeServiceId && this.$refs.form.validate()) {
        // ✅ Do NOT access `.hex`; v-model already holds a hex string
        await this.$store.dispatch("updateAppointmentTypeService", {
          payload: this.form,
          id: this.appointmentTypeServiceId,
        });
        this.$router.back();
      } else {
        console.log(this.$refs.form);
      }
    },
  },

  mounted() {
    this.appointmentTypeServiceId = +this.$route.params.id;

    apolloClient
        .query({
          query: gql`
          query fetchDate($id: Int!) {
            findOneAppointmentTypeServiceById(id: $id) {
              id
              name
              durationInMint
              color
            }
          }
        `,
          context: {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("accessToken"),
            },
          },
          variables: {
            id: this.appointmentTypeServiceId,
          },
        })
        .then((response) => {
          const dto = response.data.findOneAppointmentTypeServiceById || {};
          const { name = null, durationInMint = null, color = "#ffffff" } = dto;

          // ✅ keep the same object reference (safer with Vue reactivity)
          this.form.name = name;
          this.form.durationInMint = durationInMint;
          this.form.color = color || "#ffffff";

          this.breadcrumb = `Editing ${this.form.name || ""}`;
        });
  },

  computed: {
    getTimeSlots() {
      const timeSlots = [];
      for (let i = 5; i <= 480; i += 5) timeSlots.push(i);
      return timeSlots;
    },
  },
};
</script>

<style scoped>
.v-card__title {
  background-color: #a8e3e1;
}

@media (max-width: 600px) {
  .v-color-picker {
    max-width: 100%;
  }
}
</style>
